import {useMemo} from 'react';
import type {RightPanelConfig} from 'components/scene/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import {ColorPalette} from 'theme';
import type {
  LinkedValueSearchPageConfig,
  LinkedValueSearchSceneExtensionCore,
} from '../types';
// eslint-disable-next-line import/no-cycle
import {LinkedValueSearchContainer} from '../LinkedValueSearchContainer';
import {useLinkedValueSearchFieldExtension} from './useLinkedValueSearchFieldExtension';

const defaultConfig: Partial<RightPanelConfig> = {};

export const useLinkedValueSearchSceneExtensionCore = (
  config: Partial<RightPanelConfig> = defaultConfig,
  pageConfig?: LinkedValueSearchPageConfig,
) => {
  const linkedValueSearchFieldExtension = useLinkedValueSearchFieldExtension();

  return useMemo((): LinkedValueSearchSceneExtensionCore => {
    return {
      type: FieldExtensionEnum.linkedValueSearch,
      panelConfig: {
        backgroundColour: ColorPalette.enhancedBrown,
        ...config,
      },
      renderRightPanel: () => <LinkedValueSearchContainer />,
      fieldContext: linkedValueSearchFieldExtension,
      pageConfig: pageConfig,
    };
  }, [config, linkedValueSearchFieldExtension, pageConfig]);
};
